if (!customElements.get('product-details-tabs')) {
  customElements.define(
    'product-details-tabs',
    class ProductDetailsTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });
        this.activateTab(this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0]);
      }

      activateTab(activeTab) {
        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);

          tab.setAttribute('aria-selected', isActive);
          tab.tabIndex = isActive ? 0 : -1;
          if (panel) panel.hidden = !isActive;
        });
      }

      onKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;

        event.preventDefault();
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (currentIndex + direction + this.tabs.length) % this.tabs.length;
        const nextTab = this.tabs[nextIndex];

        this.activateTab(nextTab);
        nextTab.focus();
      }
    }
  );
}
